/*
 * @Description:
 * @Author: fal
 * @Date: 2025-02-28 10:17:10
 * @FilePath: \xhlz_pc\src\project\router\modules\doer.js
 * @LastEditTime: 2025-09-24 16:05:39
 */
export const doerRoutes = [
  // 控制面板
  {
    path: '/doer/index',
    name: 'doerIndex',
    component: () => import('@/project/views/doer/panel/index'),
    meta: {
      title: '控制面板',
    },
  },
  // 企业资料
  {
    path: '/doer/profile/index',
    name: 'doerProfile',
    component: () => import('@/project/views/doer/profile/index'),
    meta: {
      title: '企业资料',
    },
  },
  // 编辑企业资料
  {
    path: '/doer/profile/edit',
    name: 'doerProfileEdit',
    component: () => import('@/project/views/doer/profile/editProfile'),
    meta: {
      title: '企业资料',
    },
  },
  // 资质证书
  {
    path: '/doer/profile/cert',
    name: 'doerCert',
    component: () => import('@/project/views/doer/profile/cert'),
    meta: {
      title: '资质证书',
    },
  },
  // 企业业绩
  {
    path: '/doer/profile/performance',
    name: 'doerPerformance',
    component: () => import('@/project/views/doer/profile/performance'),
    meta: {
      title: '企业业绩',
    },
  },
  // 账号管理
  {
    path: '/doer/profile/permission',
    name: 'doerPermission',
    component: () => import('@/project/views/doer/profile/permission'),
    meta: {
      title: '账号管理',
    },
  },
  // 工程项目
  {
    path: '/doer/procedure',
    name: 'doerProcedure',
    component: () => import('@/project/views/doer/procedure/index'),
    meta: {
      title: '工程项目',
    },
  },
  // 工程项目
  {
    path: '/doer/procedure/details',
    name: 'doerProcedureDetails',
    component: () => import('@/project/views/doer/procedure/details'),
    meta: {
      title: '工程项目',
    },
  },
  // 材料管理
  {
    path: '/doer/material',
    name: 'doerMaterial',
    component: () => import('@/project/views/doer/material/index'),
    meta: {
      title: '材料管理',
    },
  },
  // 材料管理--审批记录
  {
    path: '/doer/material/approvalRecord',
    name: 'doerApprovalRecord',
    component: () => import('@/project/views/doer/material/approvalRecord'),
    meta: {
      title: '材料管理',
    },
  },
  // 合同管理
  {
    path: '/doer/contract',
    name: 'doerContract',
    component: () => import('@/project/views/doer/contract/index'),
    meta: {
      title: '合同管理',
    },
  },
  // 劳务合同明细
  {
    path: '/doer/contract/depart',
    name: 'doerContractDepart',
    component: () => import('@/project/views/doer/contract/depart'),
    meta: {
      title: '劳务合同',
    },
  },
  // 材料合同明细
  {
    path: '/doer/contract/material',
    name: 'doerContractMaterial',
    component: () => import('@/project/views/doer/contract/material'),
    meta: {
      title: '材料合同',
    },
  },
  // 机械合同明细
  {
    path: '/doer/contract/machine',
    name: 'doerContractMachine',
    component: () => import('@/project/views/doer/contract/machine'),
    meta: {
      title: '机械合同',
    },
  },
  // 税额明细明细
  {
    path: '/doer/contract/tax',
    name: 'doerContractTax',
    component: () => import('@/project/views/doer/contract/tax'),
    meta: {
      title: '税额明细',
    },
  },
  // 供应商管理
  {
    path: '/doer/supplier',
    name: 'doerSupplier',
    component: () => import('@/project/views/doer/supplier/index'),
    meta: {
      title: '供应商管理',
    },
  },
  // 信息管理
  // 招聘管理
  {
    path: '/doer/infoMag/hire',
    name: 'doerHire',
    component: () => import('@/project/views/doer/infoMag/hire'),
    meta: {
      title: '招聘管理',
    },
  },
  // 发布、编辑招聘
  {
    path: '/doer/infoMag/updateHire',
    name: 'doerUpdateHire',
    component: () => import('@/project/views/doer/infoMag/components/hire/updateInfo'),
    meta: {
      title: '人才招聘',
    },
  },
  // 查看招聘人才
  {
    path: '/doer/infoMag/viewHire',
    name: 'doerViewHire',
    component: () => import('@/project/views/doer/infoMag/components/hire/viewInfo'),
    meta: {
      title: '查看人才招聘',
    },
  },
  {
    path: '/doer/infoMag/laborQuoteList',
    name: 'doerLaborQuoteList',
    component: () => import('@/project/views/doer/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 劳务采购
  {
    path: '/doer/infoMag/laborDemand',
    name: 'doerLaborDemand',
    component: () => import('@/project/views/doer/infoMag/laborDemand'),
    meta: {
      title: '劳务采购',
    },
  },
  {
    path: '/doer/infoMag/laborQuoteList',
    name: 'doerLaborQuoteList',
    component: () => import('@/project/views/doer/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 材料采购发布
  {
    path: '/doer/infoMag/material',
    name: 'doerMaterial',
    component: () => import('@/project/views/doer/infoMag/material'),
    meta: {
      title: '材料采购',
    },
  },
  {
    path: '/doer/infoMag/materialQuoteList',
    name: 'doerMaterialQuoteList',
    component: () => import('@/project/views/doer/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 机械采购发布
  {
    path: '/doer/infoMag/machine',
    name: 'doerMachine',
    component: () => import('@/project/views/doer/infoMag/machine'),
    meta: {
      title: '机械采购',
    },
  },
  {
    path: '/doer/infoMag/machineQuoteList',
    name: 'doerMachineQuoteList',
    component: () => import('@/project/views/doer/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 咨询业务
  {
    path: '/doer/infoMag/comprehensive',
    name: 'doerComprehensive',
    component: () => import('@/project/views/doer/infoMag/comprehensive'),
    meta: {
      title: '咨询业务',
    },
  },
  {
    path: '/doer/infoMag/comprehensiveQuoteList',
    name: 'doerComprehensiveQuoteList',
    component: () => import('@/project/views/doer/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 平台推送
  {
    path: '/doer/push',
    name: 'doerPush',
    // component: () => import('@/project/views/doer/push/push'),
    component: () => import('@/views/common/push/index.vue'),
    meta: {
      title: '平台推送',
    },
  },
  // 证书管理
  {
    path: '/doer/cert',
    name: 'doerCert',
    component: () => import('@/project/views/doer/cert/index'),
    meta: {
      title: '证书管理',
    },
  },
  // 人员证书管理
  {
    path: '/doer/cert/person',
    name: 'doerPrsonnelCert',
    component: () => import('@/project/views/doer/cert/personCert'),
    meta: {
      title: '证书管理',
    },
  },
  // 人员证书管理-项目在建情况
  {
    path: '/doer/cert/project',
    name: 'doerProject',
    component: () => import('@/project/views/doer/cert/projectList'),
    meta: {
      title: '证书管理',
    },
  },
  // 项目保证金
  {
    path: '/doer/bond',
    name: 'doerBond',
    component: () => import('@/project/views/doer/bond/index'),
    meta: {
      title: '项目保证金',
    },
  },
];
